import { OperationTypeInterface } from '@/manager/sync/operationType.interface';

export const Income = 1;
export const Expense = 2;

export interface OperationInterface {
    id?: string;
    numberOrder?: string;
    date?: string;
    dateValue?: string;
    amount?: number;
    badge?: string;
    balance?: number;
    concept?: string;
    conceptCode?: string;
    operationType: number;
    type?: OperationTypeInterface;
    product?: string;
    delegation?: string;
    trainer?: string;
    client?: string;
    inversion?: boolean;
    lastChangeAuthor?: string;
}

export class Operation implements OperationInterface {
    public id?: string;
    public numberOrder?: string;
    public date?: string;
    public dateValue?: string;
    public amount?: number;
    public badge?: string;
    public balance?: number;
    public concept?: string;
    public conceptCode?: string;
    public operationType: number;
    public type?: OperationTypeInterface;
    public product?: string;
    public delegation?: string;
    public trainer?: string;
    public client?: string;
    public inversion?: boolean;
    public lastChangeAuthor?: string;

    public constructor() {
        this.operationType = 1;
    }
}
